import request from '../utils/request';

// 登录
export const login = (data) => {
  return request({
    url: '/api/manage/login',
    method: 'post',
    data
  });
};

// 获取用户信息
export const getUserInfo = () => {
  return request({
    url: '/api/manage/getUserInfo',
    method: 'get'
  });
};

// 获取在线状态
export const getOnlineStatus = () => {
  return request({
    url: '/api/manage/getOnlineStatus',
    method: 'get'
  });
};

// 切换在线状态
export const switchOnlineStatus = (onlineStatus) => {
  return request({
    url: '/api/manage/switchOnlineStatus',
    method: 'post',
    params: { onlineStatus }
  });
};

// 登出
export const logout = () => {
  return request({
    url: '/auth/logout',
    method: 'post'
  });
};


